import { Link } from 'react-router-dom';
import { Progress } from '../ui/progress';
import { Button } from '../ui/button';
import { useCatalogImportJob } from './CatalogImportJobContext';

export function CatalogImportProgressBanner() {
  const { job, clearJob } = useCatalogImportJob();
  if (!job) return null;

  const active = job.status === 'queued' || job.status === 'running';
  const failed = job.status === 'failed';
  const done = job.status === 'completed';

  if (!active && !failed && !done) return null;

  // Keep completed/failed visible briefly until dismissed
  if ((done || failed) && !job.finishedAt) return null;

  return (
    <div
      className={
        failed
          ? 'border-b border-destructive/40 bg-destructive/10'
          : done
            ? 'border-b border-emerald-500/30 bg-emerald-500/10'
            : 'border-b bg-background'
      }
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-3 sm:flex-row sm:items-center sm:gap-4">
        <div className="min-w-0 flex-1 space-y-1">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
            <span className="font-medium">
              {failed
                ? 'Catalog import failed'
                : done
                  ? job.dryRun
                    ? 'Catalog dry run complete'
                    : 'Catalog import complete'
                  : 'Catalog import in progress'}
            </span>
            <span className="tabular-nums text-muted-foreground">{job.progress.percent}%</span>
            <span className="truncate text-muted-foreground">{job.progress.label}</span>
          </div>
          <Progress value={job.progress.percent} className="h-2" />
          {failed && job.error && (
            <p className="text-xs text-destructive">{job.error}</p>
          )}
          {done && job.result && (
            <p className="text-xs text-muted-foreground">
              {job.result.categoriesImported} categories · {job.result.productsImported} products ·{' '}
              {job.result.machinesImported} machines · {job.result.slotsImported} slots
            </p>
          )}
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Button variant="outline" size="sm" asChild>
            <Link to="/settings/integrations">Integrations</Link>
          </Button>
          {(done || failed) && (
            <Button variant="ghost" size="sm" onClick={clearJob}>
              Dismiss
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
